import { cn } from "@/lib/utils";
import { ArrowLeft } from "lucide-react";
import { textVariants } from "./Text/Text";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

interface Props {
  route?: string;
  backFn?: () => void;
}

const GoBack = ({ route, backFn }: Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const trans = (key: string) => t(`app.components.back.${key}`);
  return (
    <div className="flex">
      <div
        onClick={() => (backFn ? backFn() : navigate((route as string) ?? -1))}
        className="flex items-center gap-1 mb-2 cursor-pointer bg-gray-200 dark:bg-grey-500 py-1 px-2 rounded-xl "
      >
        <ArrowLeft className="h-5 w-5 dark:text-white" />
        <span
          className={cn(
            textVariants({ size: "sm", font: "medium" }),
            "md:text-sm text-xs cursor-pointer"
          )}
        >
          {trans("label")}
        </span>
      </div>
    </div>
  );
};

export default GoBack;
